var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useQueries, useQueryClient, } from '@tanstack/react-query';
import { FILESPACE_LIST_REFETCH_INTERVAL } from '#constants';
import { useAuthProvider, useLucidSdk } from '#context';
import { canFetchWorkspaceData, filespaceListByWorkspaceIdQueryFactory, useUserWorkspaces, workspaceLoginStatusQueryFactory, } from '#query-hooks';
import { isPendingMember } from '#services';
// Used to refetch data in cases where access to a filespace has been added/removed
export const usePollFilespaceLists = () => {
    _react_refresh_temp_1();
    const { lucidSdk } = useLucidSdk();
    const { currentUser } = useAuthProvider();
    const queryClient = useQueryClient();
    const { query: { data: workspaces }, } = useUserWorkspaces();
    // Get workspace login status - used below to make requests for filespaceList
    const workspaceLoginStatuses = useQueries({
        queries: workspaces?.map(({ id }) => ({
            ...workspaceLoginStatusQueryFactory({
                lucidSdk,
                workspaceId: id,
            }),
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion -- pins 'always' to NetworkMode so useQueries options typecheck (lint:tsc needs it; projectService mis-judges as unnecessary)
            networkMode: 'always',
            enabled: Boolean(currentUser?.emailVerified && id !== ''),
        })) || [],
    });
    // Skip pending invites and workspaces we can't yet fetch data for
    const fetchableWorkspaces = workspaces?.filter((workspaceData, index) => !isPendingMember(workspaceData, currentUser) &&
        canFetchWorkspaceData(workspaceLoginStatuses[index]?.data)) ?? [];
    const queries = useQueries({
        queries: fetchableWorkspaces.map(({ id: workspaceId }) => ({
            ...filespaceListByWorkspaceIdQueryFactory({
                lucidSdk,
                workspaceId,
                queryClient,
            }),
            refetchInterval: FILESPACE_LIST_REFETCH_INTERVAL,
            refetchIntervalInBackground: true,
        })),
    });
    return fetchableWorkspaces.map((workspace, index) => ({
        workspaceId: workspace.id,
        filespaceList: queries[index]?.data ?? [],
    }));
};
_react_refresh_temp_1(usePollFilespaceLists, "bGpSeErMnEsHxhJBJhKixj7MNLA=", false, () => [useLucidSdk, useAuthProvider, useQueryClient, useUserWorkspaces, useQueries, useQueries]);
